export default __webpack_public_path__ + "media/images/features/yado/step_1-d2ec48b93907e162e3d94001f402eb0f.jpg";